import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { ExternalCandidacyComment, HttpResponse } from "@/types";

export function useDeleteRemoveExternalCandidacyComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      candidacyId,
      externalCandidacyCommentId,
    }: {
      candidacyId: string;
      externalCandidacyCommentId: number;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/external-candidacy-comments/${externalCandidacyCommentId.toString()}`;
      const res = await guacHttpClient.delete<
        ExternalCandidacyComment,
        HttpResponse<ExternalCandidacyComment>
      >(path);
      return res.data;
    },
    onSuccess: (deletedComment, variables) => {
      queryClient.setQueryData(
        [
          "external-candidacy-comments",
          currentCompanyId,
          currentJobId,
          variables.candidacyId,
        ],
        (cachedData?: ExternalCandidacyComment[]) => {
          if (!cachedData) return cachedData;
          return cachedData.filter(
            (comment) => comment.id !== deletedComment.id,
          );
        },
      );
    },
  });
}
